module.exports = __webpack_public_path__ + "static/media/lp-img-4.d6fb2df5.png";